"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webUiEventNames = void 0;
const eventNamePrefix = 'AESOP';
exports.webUiEventNames = {
    addProductsToCart: `${eventNamePrefix}addProductsToCart`,
    openLoginModal: `${eventNamePrefix}openLoginModal`,
    mountAddressBook: `${eventNamePrefix}mountAddressBook`,
};
//# sourceMappingURL=webUiEventNames.js.map